import reducer from "./reducer";
export { default as PaymentTypes } from "./components/index";
export { default as paymentTypesReducerName } from "./constants";
export default reducer;
